import {useEffect, useState} from 'react';
import axios from 'axios';
import Constants from '../Configuration';
import {IPriceInfo} from './usePayment';

const usePublicSubscriptionPrices = () => {
    const [prices, setPrices] = useState<IPriceInfo[]>([]);
    const [isLoading, setIsLoading] = useState(true);
    useEffect(() => {
        const controller = new AbortController();
        axios.get<IPriceInfo[]>(Constants.apiEndpoint + 'info/prices/public', {signal: controller.signal, timeout: 15000})
            .then(response => {
                if (!controller.signal.aborted) setPrices(response.data);
            })
            .catch(() => {})
            .finally(() => {
                if (!controller.signal.aborted) setIsLoading(false);
            });
        return () => controller.abort();
    }, []);
    return {prices, isLoading};
};

export default usePublicSubscriptionPrices;
